import { connect } from 'react-redux';
import Overview from './Overview';
import { getData } from '../../actions/utils';
import hallsSchema from '../../normalizr-schemas/hallsSchema';

const mapStateToProps = ({ halls, currentOrganisation }) => ({
  halls,
  currentOrganisation,
});

const mapDispatchToProps = dispatch => ({
  getOrganisationHalls: () => dispatch(getData('halls', 'halls', hallsSchema, false)),
});

const OverviewContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Overview);

export default OverviewContainer;



// WEBPACK FOOTER //
// ./src/components/Overview/OverviewContainer.js